import { RadioGroup, styled } from "@mui/material"

export const StyledRadioGroup = styled(RadioGroup)({
  marginLeft: "12px",
  gap: "24px",
  "& input[type='radio']": {
    margin: 0
  }
})

export const StyledRadioGroupLabel = styled("div")({
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "20px"
})
